// extracted by mini-css-extract-plugin
export default {"container":"Decorator_container__BtQG-","decorator":"Decorator_decorator__qIJ64"};